// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/KaTeX_AMS-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/KaTeX_Caligraphic-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/KaTeX_Caligraphic-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/KaTeX_Fraktur-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/KaTeX_Fraktur-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/KaTeX_Main-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/KaTeX_Main-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/KaTeX_Main-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/KaTeX_Main-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/KaTeX_Math-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/KaTeX_Math-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/KaTeX_SansSerif-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/KaTeX_SansSerif-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/KaTeX_SansSerif-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/KaTeX_Script-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/KaTeX_Size1-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/KaTeX_Size2-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/KaTeX_Size3-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/KaTeX_Size4-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/KaTeX_Typewriter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "KaTeX_AMS";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Caligraphic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Caligraphic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Fraktur";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Fraktur";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Main";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Main";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Main";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Main";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Math";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Math";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_SansSerif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_SansSerif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_SansSerif";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Script";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Size1";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Size2";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Size3";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Size4";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2");
  font-weight: normal;
  font-style: normal; }

@font-face {
  font-family: "KaTeX_Typewriter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2");
  font-weight: normal;
  font-style: normal; }
`, "",{"version":3,"sources":["webpack://./src/styles/latex_fonts.scss"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,4DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,gCAAgC;EAChC,4DAAiE;EACjE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,gCAAgC;EAChC,4DAAoE;EACpE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,4BAA4B;EAC5B,4DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,4BAA4B;EAC5B,4DAAgE;EAChE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,4DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,4DAAgE;EAChE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,4DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,4DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,4DAAgE;EAChE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,yBAAyB;EACzB,6DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,8BAA8B;EAC9B,6DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,8BAA8B;EAC9B,6DAAiE;EACjE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,8BAA8B;EAC9B,6DAAkE;EAClE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,2BAA2B;EAC3B,6DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,0BAA0B;EAC1B,6DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,0BAA0B;EAC1B,6DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,0BAA0B;EAC1B,6DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,0BAA0B;EAC1B,6DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,+BAA+B;EAC/B,6DAAmE;EACnE,mBAAmB;EACnB,kBAAkB,EAAA","sourcesContent":["@font-face {\n  font-family: \"KaTeX_AMS\";\n  src: url(\"../fonts/KaTeX_AMS-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Caligraphic\";\n  src: url(\"../fonts/KaTeX_Caligraphic-Bold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Caligraphic\";\n  src: url(\"../fonts/KaTeX_Caligraphic-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Fraktur\";\n  src: url(\"../fonts/KaTeX_Fraktur-Bold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Fraktur\";\n  src: url(\"../fonts/KaTeX_Fraktur-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Main\";\n  src: url(\"../fonts/KaTeX_Main-Bold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Main\";\n  src: url(\"../fonts/KaTeX_Main-BoldItalic.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Main\";\n  src: url(\"../fonts/KaTeX_Main-Italic.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Main\";\n  src: url(\"../fonts/KaTeX_Main-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Math\";\n  src: url(\"../fonts/KaTeX_Math-BoldItalic.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Math\";\n  src: url(\"../fonts/KaTeX_Math-Italic.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_SansSerif\";\n  src: url(\"../fonts/KaTeX_SansSerif-Bold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_SansSerif\";\n  src: url(\"../fonts/KaTeX_SansSerif-Italic.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_SansSerif\";\n  src: url(\"../fonts/KaTeX_SansSerif-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Script\";\n  src: url(\"../fonts/KaTeX_Script-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Size1\";\n  src: url(\"../fonts/KaTeX_Size1-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Size2\";\n  src: url(\"../fonts/KaTeX_Size2-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Size3\";\n  src: url(\"../fonts/KaTeX_Size3-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Size4\";\n  src: url(\"../fonts/KaTeX_Size4-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"KaTeX_Typewriter\";\n  src: url(\"../fonts/KaTeX_Typewriter-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
